"use client";

import Link from "next/link";
import { FreeMode, Mousewheel, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import style from "./quickSearchSwiper.module.scss";

const QuickSearchSwiper = ({ searchData }: { searchData: SearchData | null }) => {
  return (
    <div id={style["header-secondary-swiper"]} className={style.quickSearchContainer}>
      <Swiper
        modules={[FreeMode, Mousewheel, Navigation]}
        spaceBetween={5}
        slidesPerView={"auto"}
        loop={false}
        freeMode={{
          enabled: true,
          sticky: true,
        }}
        direction="horizontal"
        mousewheel={false}
      >
        {searchData?.searches
          .filter((item) => item.search && item.search.trim() !== "")
          .map((item, index) => (
            <SwiperSlide key={index} className={style.swiperElement}>
              <Link
                prefetch={false}
                href={`/search?query=${encodeURIComponent(item.search)}`}
                className={style.quickSearchLink}
              >
                {item.search}
              </Link>
            </SwiperSlide>
          ))}
      </Swiper>
    </div>
  );
};

export default QuickSearchSwiper;
